<template>
  <div class="no-overflow-modal">
    <div v-if="applicantData && form" class="no-overflow-modal">
      <div class="columns">
        <div dir="ltr" class="column b-r has-text-left">
          <ApplicantControlModule :applicantData="applicantData" />

          <div class="box">
            <div class="field">
              <label class="label">Job Description</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="..."
                  v-model="jobDescription"
                  name="job_description"
                  @focusout="handleTextFieldSubmit"
                />
              </div>
            </div>

            <PreferredWorkRegion
              :applicantId="applicantData.resource_id"
              v-model="form.data.applicant.fields.preferred_work_region.value"
            />

            <SalaryExpectations field="min"
              :applicantId="applicantData.resource_id"
              v-model="form.data.applicant.fields.min_salary_expectations.value"
              @error="validateMinSalaryExpectations"
            />

            <div class="is-flex is-justify-content-space-between is-align-items-end">
              <SalaryExpectationsComment class="m-0" :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.salary_expectations_comment.value" />
              <SalaryRespondedAt :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.salary_responded_at.value" />
            </div>
          </div>

          <ApplicantJobTitles v-if="applicantData" @updateJobTitles="updateApplicantJobTitles" :applicant="applicantData" />

          <div class="box">
            <p class="columns has-text-left">
              <b class="column">Applicant ID: </b>
              <span class="column">{{applicantData.resource_id}}</span>
            </p>

            <PhoneNumber :userId="userId" v-model="form.data.applicant.fields.phone_number.value" />

            <Email :userId="userId" v-model="form.data.applicant.fields.email.value" />

            <FreeSubmission :applicantId="applicantData.resource_id" v-model="freeSubmission" :approvedAt="freeSubmissionApprovedAt" @update:approvedAt="freeSubmissionApprovedAt = $event" />

            <Gender :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.gender.value" />

            <IsDiscrete :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.is_discrete.value" />

            <QuestionYesNo :question="questionsData.approve_email" title="האם אתה מעוניין שנשלח לך הצעות ועדכונים באימייל?" fieldStyle="mb-3" :initValue="handleQuestionInitValue(questionsData.approve_email)" @input="handleQuestionYesNoInput" />

            <Owner :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.owner.value" />

            <div class="mb-5 mt-3">
              <RestrictWhatsappDate :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.restrict_whatsapp_date.value" />
            </div>

            <div class="mb-5">
              <LocationEditor :onSubmit="handleLocation" :payload="{ location: {description: location}, resource_type: 'Applicant', resource_id: applicantData.resource_id }" />
            </div>

            <Status :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.status.value" :owner="form.data.applicant.fields.owner.value" />

          </div>

          <ApplicantJobHistory v-if="applicantData" :applicant="applicantData" />

          <div class="box">
            <div class="is-flex is-justify-content-space-between">
              <h4 class="title is-size-5 mr-5">Skills</h4>
              <label class="checkbox p-0">
                <span class="is-size-7">{{ skillsFilter ? 'Filtered' : 'Not filtered' }}</span>
                <input type="checkbox" v-model="skillsFilter" />
              </label>
            </div>
            <table class="table rtl">
              <tbody>
                <tr v-for="skill in withApplicantSkill" :key="skill.id">
                  <td class="has-text-right bold">{{ skill.question_text }}</td>
                  <td style="width: 40px">
                    <button class="button" :class="{'is-success': skill.has_experience === true}" @click="answerSkillQuestion(skill, true)">Yes</button>
                  </td>
                  <td style="width: 40px">
                    <button class="button" :class="{'is-danger': skill.has_experience === false}" @click="answerSkillQuestion(skill, false)">No</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="box">
            <!-- work on friday skill -->
            <!-- work on friday -->
            <table class="table">
              <tbody>
                <tr v-for="skill in specialSkills" :key="skill.id">
                  <td class="bold">{{ skill.question_text }}</td>
                  <td style="width: 40px">
                    <button class="button" :class="{'is-success': skill.has_experience === true}" @click="answerSkillQuestion(skill, true)">Yes</button>
                  </td>
                  <td style="width: 40px">
                    <button class="button" :class="{'is-danger': skill.has_experience === false}" @click="answerSkillQuestion(skill, false)">No</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div dir="ltr" class="column b-r is-4 has-text-left mr-3">
          <div class="box mb-5">
            <Message :userId="userId" :applicantId="applicantId" v-model="form.data.applicant.fields.message.value" />
          </div>

          <div class="mb-5">
            <div class="columns is-justify-content-space-between is-align-items-center is-align-content-center">
              <div class="column">
                <!-- <div class="mb-2"><b>Abstract Updated At:</b> {{ $moment(abstractUpdatedAt).format('DD/MM/YYYY hh:mm') }}</div> -->
              </div>
              <div class="column has-text-right">
                <button class="button is-info" @click="generateAbstract">Generate Abstruct</button>
              </div>
            </div>
            <Abstract :applicantId="applicantData.resource_id" v-model="form.data.applicant.fields.abstract.value" :isEditable="true"/>
          </div>

          <div class="box mb-5">
            <div class="mt-5">
              <textarea
                placeholder="Internal Note"
                class="textarea is-fullwidth"
                v-model="internalNotes"
              >
              </textarea>
              <button @click="submitInternalNotes" class="button is-info is-fullwidth mt-4" :disabled="!internalNotes">Submit Internal Note</button>
            </div>
          </div>

          <div class="box is-flex px-6 is-justify-content-space-between">
            <button class="button is-info" @click="generateOffers">Generate Offers</button>
            <button class="button is-info" @click="generateAbstract" :disabled="!allSkillQuestionAnswered">Generate Abstract</button>
          </div>

        </div>
        <div class="column column-width b-r is-flex is-flex-direction-column" style="overflow: hidden;">
          <div class="p-1 is-flex-grow-1">
            <ApplicantCvPdf :payload="applicantData" containerStyle="profile-container" class="full_height applicant_cv_pdf applicant_profile_html_container" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

import TextsHelper from '@/custom/classes/texts_helper.js'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import SkillsHelper from '@/custom/classes/skills_helper.js'

import ApplicantCvPdf from '@/components/ApplicantCvPdf'
import LocationEditor from '@/components/LocationEditor'
import QuestionYesNo from '@/components/QuestionYesNo'
import ApplicantJobTitles from '@/components/entities/applicant/JobTitles'
import ApplicantJobHistory from '@/components/ApplicantJobHistory'
import FreeSubmission from '@/components/entities/applicant/FreeSubmission'
import IsDiscrete from '@/components/entities/applicant/IsDiscrete'
import Status from '@/components/entities/applicant/Status'
import Abstract from '@/components/entities/applicant/Abstract'
import Owner from '@/components/entities/applicant/Owner'
import Gender from '@/components/entities/applicant/Gender'
import SalaryExpectations from '@/components/entities/applicant/SalaryExpectations.vue'
import SalaryExpectationsComment from '@/components/entities/applicant/SalaryExpectationsComment'
import SalaryRespondedAt from '@/components/entities/applicant/SalaryRespondedAt'
import Message from '@/components/entities/applicant/Message'
import Email from '@/components/entities/applicant/Email'
import PhoneNumber from '@/components/entities/applicant/PhoneNumber'
import ApplicantControlModule from '@/components/shared/organisms/ApplicantControlModule.vue'
import RestrictWhatsappDate from '@/components/entities/applicant/RestrictWhatsappDate'
import PreferredWorkRegion from '@/components/entities/applicant/PreferredWorkRegion'

export default {
  name: 'ModalVettingForm',
  components: {
    ApplicantCvPdf,
    LocationEditor,
    QuestionYesNo,
    ApplicantJobTitles,
    ApplicantJobHistory,
    FreeSubmission,
    RestrictWhatsappDate,
    IsDiscrete,
    Status,
    Abstract,
    Owner,
    Gender,
    SalaryExpectations,
    SalaryExpectationsComment,
    SalaryRespondedAt,
    Message,
    Email,
    PhoneNumber,
    ApplicantControlModule,
    PreferredWorkRegion
  },
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      questionsHelper: new QuestionsHelper(),
      skills_helper: new SkillsHelper(),
      applicantData: undefined,
      // Kept OUT of the form fields on purpose: form.js#getData sends every
      // field on each mySubmit(), and echoing the expiry back is not a toggle.
      // FreeSubmission saves the consent itself (free_submission_consent).
      freeSubmission: null,
      freeSubmissionApprovedAt: null,
      selectedSkills: {},
      applicantSkill: {},
      questionsData: {},
      specialSkills: {},
      internalNotes: undefined,
      jobDescription: '',
      form: undefined,
      location: undefined,
      componentIsVettedKey: 0,
      messageLengthLimit: 500,
      skillsFilter: true,
      MinSalaryExpectationsError: false,
      quillConfig: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ direction: 'rtl' }]
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters('admins', ['activeAdmins']),
    ...mapGetters('skills', ['allGeneralSkills']),
    userId () {
      if (!this.applicantData) return null
      return this.applicantData.user_id != null ? this.applicantData.user_id : this.applicantData.id
    },
    applicantId () {
      if (!this.applicantData) return null
      return this.applicantData.applicant_id != null ? this.applicantData.applicant_id : this.applicantData.resource_id
    },
    withApplicantSkill () {
      const d = Object.values(this.selectedSkills).map(s => {
        const applicantSkill = this.applicantSkill[s.id]
        return applicantSkill ? { ...s, has_experience: applicantSkill.has_experience } : s
      }).sort((a, b) => b.priority - a.priority).filter(s => {
        return this.skillsFilter ? s.has_experience !== false : true
      })
      return d
    },
    allSkillQuestionAnswered () {
      return this.withApplicantSkill.length && this.withApplicantSkill.every(skill => skill.has_experience !== undefined)
    }
  },
  async created () {
    this.applicantData = await this.$network_utils.getApplicant({ id: this.payload.applicant_id })
    this.freeSubmission = this.applicantData.free_submission || null
    this.freeSubmissionApprovedAt = this.applicantData.free_submission_approved_at || null
    const r = await this.$network_utils.getApplicantSkills({ current_applicant_id: this.payload.applicant_id })
    r.forEach(e => {
      this.applicantSkill = { ...this.applicantSkill, [e.skill.id]: { ...e.skill, has_experience: e.details.has_experience } }
    })
    const designators = 'approve_email'
    const questions = await this.$network_utils.getResourceQuestions({ current_type: 'Applicant', current_resource_id: this.payload.applicant_id, designators: designators })
    questions.forEach((q, _, a) => {
      this.questionsData[q.designator] = this.questionsHelper.getQuestionByDesignator(a, q.designator)
    })
    this.setForm(this.applicantData)
    this.location = this.applicantData.location
    this.getSpecialSkills()
    this.getTexts()
  },
  watch: {
    'form.data.applicant.fields.message.value' (newVal, oldVal) {
      if (newVal.length > this.messageLengthLimit) {
        this.form.data.applicant.fields.message.value = oldVal
      }
    }
  },
  methods: {
    ...mapMutations('modals', ['create']),
    validateMinSalaryExpectations (state) {
      this.MinSalaryExpectationsError = state
    },
    async updateApplicantJobTitles (jobTitles) {
      for (const title of jobTitles) {
        await this.loadJobTitleSkills(title.id)
      }
    },
    handleFocusOut () {
      this.form.mySubmit()
    },
    async handleTextFieldSubmit ({ target }) {
      await this.$network_utils.postText({
        designator: target.name,
        content: target.value,
        current_resource_id: this.payload.applicant_id,
        current_type: 'Applicant'
      })
    },
    async getSpecialSkills () {
      const skillsName = ['עבודה בימי שישי', 'עבודה בימי שישי לסירוגין', 'משרה מלאה', 'עבודה בלילה']
      for (let i = 0; i < skillsName.length; i++) {
        const skill = skillsName[i]
        const [ result ] = await this.$network_utils.getAllSkills({ name_eq: skill })
        if (result) {
          this.specialSkills[result.id] = result
        }
      }
      this.getSkills()
    },
    async answerSkillQuestion (skill, answer) {
      const response = await this.$network_utils.postApplicantSkill({ skill_id: skill.id, current_applicant_id: this.applicantData.resource_id, has_experience: answer })
      skill.has_experience = answer
      this.specialSkills = { ...this.specialSkills, [response.skill.id]: { ...skill } }
    },
    async getSkills () {
      await this.$network_utils
        .getApplicantSkills({
          current_applicant_id: this.payload.applicant_id
        })
        .then(response => {
          response.forEach(s => {
            const skill = this.specialSkills[s.skill.id]
            if (skill) {
              skill.has_experience = s.details.has_experience
            }
          })
          this.skills_by_category = this.skills_helper.getSkillsByCategory(
            response
          )
        })
    },
    async getTexts () {
      const texts = await this.$network_utils.getResourceTexts({ current_type: 'Applicant', current_resource_id: this.payload.applicant_id })
      this.jobDescription = (texts.find(text => text.designator == 'job_description') || {}).content
    },
    handleQuestionInitValue (question) {
      const [ a ] = this.questionsHelper.getAnsweredOptionIdsFromQuestion(question)
      return a ? a.toString() : ''
    },
    handleLocation (data) {
      this.location = data
    },
    async handleQuestionYesNoInput (data) {
      await this.$network_utils.postQuestionAnswer({
        question_id: data.id,
        option_ids: data.answer,
        designator: data.designator,
        current_resource_id: this.payload.applicant_id,
        current_type: 'Applicant'
      })
    },
    handleQuestionYesNoApplicantInput (data) {
      this.assignValueToField(data)
      this.form.mySubmit()
    },
    async handleFocusOutMessage () {
      const message = this.form.data.applicant.fields.message.value
      await this.$caller.request('put', `/users/${this.userId}`, 'admin_headers', { message: message })
      this.handleMessageChangedStat(message)
    },
    handleMessageChangedStat (message) {
      let old_message = this.applicantData.message
      if (old_message == message) {
        return
      }
      let stat_content = 'Message Changed:<br><b>Old Message was:</b> ' + old_message + '<br><b>New Message is:</b> ' + message
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: stat_content,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 7,
        resource_id: this.applicantId,
        resource_type: 'Applicant'
      })
    },
    assignValueToField (data) {
      if (data.designator === 'is_vetted' && data.answer === 'true') {
        const state = this.MinSalaryExpectationsError
        if (!state) {
          this.form.data.applicant.fields.is_vetted.value = false
          this.componentIsVettedKey += 1
          this.$utils.emit('show_toast', { text: 'נא לעדכן שכר מינימום' })
        } else {
          this.form.data.applicant.fields.is_vetted.value = data.answer
          this.postVettingStat()
        }
        return
      }
      this.form.data.applicant.fields[data.designator].value = data.answer
    },
    transformJobTitles (jobTitle) {
      return {
        ...jobTitle.job_title,
        started_at: jobTitle.started_at ? this.$moment().diff(jobTitle.started_at, 'years', true).toFixed(1) : null,
        ended_at: !!jobTitle.ended_at,
        has_experience: jobTitle.has_experience,
        is_interested: jobTitle.is_interested,
        server: true,
        experienceSelector: 'number'
      }
    },
    setForm (form_data) {
      console.log(form_data)
      this.form = new this.$form({
        applicant: {
          fields: {
            salary_expectations_comment: {
              value: form_data.salary_expectations_comment,
              has_error: false,
              validations: []
            },
            salary_responded_at: {
              value: form_data.salary_responded_at,
              has_error: false,
              validations: []
            },
            min_salary_expectations: {
              value: form_data.min_salary_expectations == undefined ? undefined : parseInt(form_data.min_salary_expectations),
              has_error: false,
              validations: ['Exists', 'Min', 'Max', 'Number'],
              min: 5000,
              max: 100000
            },
            preferred_work_region: {
              value: form_data.preferred_work_region,
              has_error: false,
              validations: []
            },
            restrict_whatsapp_date: {
              value: form_data.restrict_whatsapp_date,
              has_error: false,
              validations: []
            },
            abstract: {
              value: form_data.abstract || '',
              has_error: false,
              validations: []
            },
            is_vetted: {
              value: form_data.is_vetted,
              has_error: false,
              validations: []
            },
            status: {
              value: form_data.applicant_status,
              has_error: false,
              validations: []
            },
            message: {
              value: form_data.message || '',
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            gender: {
              value: form_data.gender,
              has_error: false,
              validations: []
            },
            email: {
              value: form_data.email,
              has_error: false,
              validations: []
            },
            phone_number: {
              value: form_data.phone_number,
              has_error: false,
              validations: []
            },
            is_discrete: {
              value: form_data.is_discrete,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: `/applicants/${this.payload.applicant_id}`,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    async onApplicantSubmit () {
      for (const key in this.questionsData) {
        const q = this.questionsData[key]
        if (!q.answerId) continue
        await this.$network_utils.postQuestionAnswer({
          question_id: q.question_id,
          option_ids: q.answerId,
          designator: q.designator,
          current_resource_id: this.payload.applicant_id,
          current_type: 'Applicant'
        })
      }
      this.form.mySubmit()
    },
    async loadJobTitleSkills (jobTitleId) {
      const jobTitleSkills = await this.$network_utils.getJobTitleSkills({ id: jobTitleId })
      const skills = [ ...this.allGeneralSkills, ...jobTitleSkills ]
      skills.forEach(skill => {
        this.selectedSkills = { ...this.selectedSkills, [skill.id]: { ...skill } }
      })
    },
    generateOffers () {
      this.$network_utils.postEvent({ current_type: 'Applicant', current_resource_id: this.payload.applicant_id, event: 'resource_updated', sidekiq_queue: 'high' }).then(() => {
        this.$utils.emit('show_toast', { text: 'מעדכן משרות' })
      })
    },
    async generateAbstract () {
      const { data, updated_at } = await this.$network_utils.createApplicantGenerateAbstract({ applicant: this.payload })
      this.abstract = data.replace(/(\\n|\.|\\n\.|\/n|\/n\.)/g, '\n')
      this.abstractUpdatedAt = updated_at
      this.$utils.emit('show_toast', { text: 'מעדכן אבסטרקט' })
    },
    async getAbstract () {
      const { data, updated_at } = await this.$network_utils.getApplicantGenerateAbstract({ applicant_id: this.payload.applicant_id })
      if (data) {
        this.abstract = data.replace(/(\\n|\.|\\n\.|\/n|\/n\.)/g, '\n')
        this.abstractUpdatedAt = updated_at
        this.$utils.emit('show_toast', { text: 'מעדכן אבסטרקט' })
      } else {
        this.generateAbstract()
      }
    },
    getBoldAbstract () {
      return this.texts_helper.getBoldContent(this.form.data.applicant.fields.abstract.value, 'abstract')
    },
    getBoldInternalNotes () {
      return this.texts_helper.getBoldContent(this.internalNotes + this.appendTimer(), 'internal_notes')
    },
    appendTimer () {
      return '\n' + this.timer
    },
    async submitAbstract () {
      await this.$network_utils.updateApplicant({ applicant_id: this.payload.applicant_id, abstract: this.getBoldAbstract() })
      this.$utils.emit('show_toast', { text: 'מעדכן אבסטרקט' })
    },
    async submitInternalNotes () {
      await this.$network_utils.postStat({
        designator: 'internal_notes',
        status: 'done',
        title: 'אימות מועמד',
        owner: this.$utils.getOwner().name,
        content: this.getBoldInternalNotes(),
        priority: 7,
        resource_id: this.payload.applicant_id,
        resource_type: 'Applicant'
      })
      this.$utils.emit('show_toast', { text: 'מעדכן internal notes' })
    },
    postVettingStat () {
      this.$network_utils.postStat({
        designator: 'applicant_vetted',
        status: 'done',
        title: 'אימות מועמד',
        owner: this.$utils.getOwner().name,
        content: 'user is vetted',
        priority: 7,
        resource_id: this.payload.applicant_id,
        resource_type: 'Applicant'
      })
    }
  }
}
</script>
<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    border: 2px solid rgba(0, 0, 0, 0.3);
  }
  .max-width-dropdown-small {
    max-width: 200px;
    border: 2px solid rgba(0, 0, 0, 0.3);
  }
  .applicant_profile_html_container{
    min-height: 100%;
    border-right: 2px solid rgba(0, 0, 0, 0.3);
    padding-right: 30px;
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
  .b-r{
    height: 65vh;
    overflow-y: auto;
  }
  .no-overflow-modal {
    overflow: hidden !important;
    height: 70vh;
  }
  .make-element-ltr-forcefull {
    direction: ltr !important;
    text-align: left !important;
  }
  .column-width {
    width: 12%;
    flex-basis: inherit;
  }
</style>
